import { NavContext } from "@/context/navContext"
import { usePathname } from "next/navigation"
import { useContext, useEffect } from "react"
import { nav } from "../../type/nav_types"
import { useTranslations } from "next-intl"

export default function Navigation() {
    const { movePage } = useContext(NavContext)
    const pathName = usePathname()
    const t = useTranslations("PageTitle");

    useEffect(()=> {
// console.log(pathName)
    }, [pathName])
    return (
        <nav id="nav-main">
            <ul>
                {
                    nav.map((nav, index) => (
                        <li key={index} className={`${nav.path == pathName && "active"}`} onClick={e => movePage(nav.path)}>
                            <div className="nav-icon">
                                <span className={`--menu ${nav.icon}`}></span>
                            </div>
                            <p>{t(nav.name)}</p>
                        </li>
                    ))
                }
            </ul>
        </nav>
    )
}